import { NgModule } from '@angular/core';
import { AgGridModule } from 'ag-grid-angular';
import { AdminLinkComponent } from './admin-link/admin-link.component';
import { AnalystRolesAdminComponent } from './analyst-roles-admin/analyst-roles-admin.component';
import { AdminRoutingModule } from './admin-routing.module';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import { MatTableModule } from '@angular/material/table';
import { FormsModule } from '@angular/forms';
import { ServerSideRowModelModule } from 'ag-grid-enterprise';
import { CommonModule, DatePipe } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { MatInputModule } from '@angular/material/input';
import { AnalystAdminComponent } from './analyst-admin/analyst-admin.component';
import { OrdersOverviewComponent } from './orders-overview/orders-overview.component';
import { MatListModule } from '@angular/material/list';
import { MatMenuModule } from '@angular/material/menu';
import { FilterChipsModule } from '@compumark/brand-context-components';
import { RerunRendererComponent } from './rerun-renderer/rerun-renderer.component';
import { ResetRendererComponent } from './reset-renderer/reset-renderer.component';
import { OrderHistoryDetailsComponent } from './order-history-details/order-history-details.component';
import { MatIconModule } from '@angular/material/icon';
import { ExportOptionsComponent } from './export-options/export-options.component';
import { ExportOptionsDialogComponent } from './export-options-dialog/export-options-dialog.component';
import { MatDialogModule } from '@angular/material/dialog';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatNativeDateModule } from '@angular/material/core';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { DateFilterDialogComponent } from './date-filter-dialog/date-filter-dialog.component';
import { ExistingUsersListComponent } from './existing-users-list/existing-users-list.component';
import { MatSidenavModule } from '@angular/material/sidenav';
import { WCLAdminResolver } from './services/wcl-admin.resolver';
import { ClientSideRowModelModule, ModuleRegistry } from 'ag-grid-community';
import { WCLAddOnsComponent } from './wcl-addons/wcl-addons.component';
import { WCLAddOnPopupLinkComponent } from './wcl-addon-popup-link/wcl-addon-popup-link.component';
import { WCLAddonDialogComponent } from './wcl-addon-dialog/wcl-addon-dialog.component';
import { WCLAdminComponent } from './wcl-admin/wcl-admin.component';
import { WCLLocationsComponent } from './wcl-locations/wcl-locations.component';
import { WCLEngineSettingsComponent } from './wcl-engine-settings/wcl-engine-settings.component';
import { MatTabsModule } from '@angular/material/tabs';

ModuleRegistry.registerModules([
  ClientSideRowModelModule,
  ServerSideRowModelModule,
]);

@NgModule({
  imports: [
    AgGridModule,
    AdminRoutingModule,
    CommonModule,
    FormsModule,
    MatButtonModule,
    MatIconModule,
    MatInputModule,
    MatTableModule,
    MatFormFieldModule,
    MatSelectModule,
    MatListModule,
    MatMenuModule,
    FilterChipsModule,
    MatDialogModule,
    MatDatepickerModule,
    MatSlideToggleModule,
    MatNativeDateModule,
    MatButtonToggleModule,
    MatSidenavModule,
    MatTabsModule,
  ],
  declarations: [
    AdminLinkComponent,
    AnalystRolesAdminComponent,
    AnalystAdminComponent,
    OrdersOverviewComponent,
    RerunRendererComponent,
    ResetRendererComponent,
    OrderHistoryDetailsComponent,
    ExportOptionsComponent,
    ExportOptionsDialogComponent,
    DateFilterDialogComponent,
    ExistingUsersListComponent,
    WCLAddOnsComponent,
    WCLAddOnPopupLinkComponent,
    WCLAddonDialogComponent,
    WCLAdminComponent,
    WCLLocationsComponent,
    WCLEngineSettingsComponent,
  ],
  providers: [DatePipe, WCLAdminResolver],
  exports: [AdminLinkComponent, ExportOptionsComponent],
})
export class AdminModule {}
